import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ConfirmationCard from '../../components/Shared/ConfirmationCardMultiActionsCard';
import TitleComponent from '../../components/Shared/TitleMultiActionsCard';

import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';
import { copyFor } from '../../copy/copy';

const CallAction = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            peopleCount={props.peopleCount}
            thankYouText={props.thankYouText}
            titleComponent={
                <TitleComponent
                    localRepresentativeState={props.localRepresentativeState}
                    useLocalRepresentative={props.useLocalRepresentative}
                    titleMultiRep={copyFor('feedback', 'representatives', 'call')}
                    titleSingleRep={copyFor(
                        'feedback',
                        'singleRecipient',
                        'call',
                        undefined,
                        { recipientName: props.repFullName }
                    )}
                    titleNoRep={copyFor(
                        'feedback',
                        'singleRecipient',
                        'call',
                        undefined,
                        { recipientName: props.recipientMask }
                    )}
                    thankYouTitle={props.thankYouTitle}
                />
            }
            {...props}
        />
    </TransitionContainerNoExit>
);

CallAction.propTypes = {
    peopleCount: PropTypes.string.isRequired,
    thankYouText: PropTypes.string.isRequired,
    repFullName: PropTypes.string.isRequired,
    recipientMask: PropTypes.string,
    localRepresentativeState: PropTypes.number,
    useLocalRepresentative: PropTypes.bool,
    thankYouTitle: PropTypes.string
};

export default connect(
    state => ({
        repFullName: state.localRep.localRepData.representative
            ? 'Rep ' + state.localRep.localRepData.representative[0].fullName
            : '',
        peopleCount:
            state.call.completeCall !== undefined
                ? state.call.completeCall.endUsersCount
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : ''
    }),
    {}
)(CallAction);
